var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 0L23.0139 17.8451L36.7028 6.2972L25.1549 19.9861L43 21.5L25.1549 23.0139L36.7028 36.7028L23.0139 25.1549L21.5 43L19.9861 25.1549L6.2972 36.7028L17.8451 23.0139L0 21.5L17.8451 19.9861L6.2972 6.2972L19.9861 17.8451L21.5 0Z",
    fill: "#0070D4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.7b99067e32674659a16508ac0fdd8a79.svg";
export { ForwardRef as ReactComponent };